import { ChevronUp, Info } from "react-feather";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../core/redux/action";
import ArrowLeft from "feather-icons-react/build/IconComponents/ArrowLeft";
import { all_routes } from "../../Router/all_routes";
import { renderRequired} from '../../feature-module/common/common.js';

const ManageService = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);

  const [service, setClient] = useState({
    serviceName: "",
    description: "",
  });

  const [errors, setErrors] = useState({});

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const handleChange = (e) => {
    setClient({
      ...service,
      [e.target.name]: e.target.value,
    });
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate service details
    if (!service.serviceName) newErrors.serviceName = "Service Name is required";
    if (!service.description) newErrors.description = "Description is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      // If validation is successful, log data to the console
      console.log("Form Data:", service);
      // You can send data to API here
    } 
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>New Service</h4>
                <h6>Create new Service</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <div className="page-btn">
                  <Link to={route.service} className="btn btn-secondary">
                    <ArrowLeft className="me-2" />
                    Back to Service List
                  </Link>
                </div>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="card">
              <div className="card-body">
                <div className="new-employee-field">
                  <div className="card-title-head">
                    <h6>
                      <span>
                        <Info className="feather-edit" />
                      </span>
                      Service Information
                    </h6>
                  </div>

                  <div className="row">
                    <div className="col-lg-12 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Service Name {renderRequired()}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="serviceName"
                          value={service.serviceName}
                          onChange={handleChange}
                        />
                        {errors.serviceName && (
                          <span className="text-danger">
                            {errors.serviceName}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Description {renderRequired()}</label>
                        <textarea
                          className="form-control"
                          name="description"
                          value={service.description}
                          onChange={handleChange}
                          rows="4" // Adjust the number of rows as needed
                        />
                        {errors.description && (
                          <span className="text-danger">
                            {errors.description}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div className="text-end mb-3">
              <Link to={route.service}type="button" className="btn btn-cancel me-2">
                Cancel
              </Link>
              <button type="submit" className="btn btn-submit">
                Save Service
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ManageService;
